import { c as _c } from "react/compiler-runtime";
import { Skeleton } from '@morpho-org/ui-v6/server';
import { cn, getFirstAndRest } from '@morpho-org/ui-v6/utils';
interface VaultHeroLoadingProps {
  name?: string | null;
  description?: string | null;
}

/**
 * Mirrors `VaultHeroClient`. A known name and description render invisibly inside their
 * blocks so the title wrap and description height match the loaded hero.
 */
const VaultHeroLoading = t0 => {
  const $ = _c(16);
  const {
    name,
    description
  } = t0;
  let t1;
  if ($[0] !== name) {
    t1 = name ? getFirstAndRest(name) : null;
    $[0] = name;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const title = t1;
  let t2;
  if ($[2] !== title) {
    t2 = title ? <div className="max-md:gap-xs flex flex-wrap gap-[24px]">{[title.first, title.rest].map(_temp)}</div> : <Skeleton className="h-[66px] w-[400px] max-w-full max-sm:h-[52px]" />;
    $[2] = title;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Skeleton className="h-[34px] w-[50px] shrink-0" />;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2) {
    t4 = <div className="gap-sm flex items-center">{t2}{t3}</div>;
    $[5] = t2;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="gap-sm flex flex-wrap items-center"><Skeleton className="h-lg w-[80px]" /><Skeleton className="h-lg w-[90px]" /><Skeleton className="h-lg w-[80px]" /></div>;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t4) {
    t6 = <div className="gap-sm flex w-full flex-col">{t4}{t5}</div>;
    $[8] = t4;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== description) {
    t7 = description && <div className="relative w-fit max-w-full"><span className="invisible block text-xs">{description}</span><Skeleton className="absolute inset-0" /></div>;
    $[10] = description;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className="gap-lg flex w-full flex-col justify-start md:flex-row md:flex-wrap"><HeroDataCard valueClassName="h-[44px]" hasSubValue={true} /><HeroDataCard valueClassName="h-[44px]" hasSubValue={true} /><HeroDataCard valueClassName="h-[38px]" /><HeroDataCard valueClassName="h-[44px]" /></div>;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t6 || $[14] !== t7) {
    t9 = <div data-testid="vault-hero" className="flex w-full flex-col gap-[48px]">{t6}{t7}{t8}</div>;
    $[13] = t6;
    $[14] = t7;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  return t9;
};
interface HeroDataCardProps {
  valueClassName: string;
  hasSubValue?: boolean;
}
const HeroDataCard = t0 => {
  const $ = _c(10);
  const {
    valueClassName,
    hasSubValue
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Skeleton className="h-md w-[120px]" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== valueClassName) {
    t2 = cn("w-[160px]", valueClassName);
    $[1] = valueClassName;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = <Skeleton className={t2} />;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== hasSubValue) {
    t4 = hasSubValue && <Skeleton className="h-md w-20" />;
    $[5] = hasSubValue;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t3 || $[8] !== t4) {
    t5 = <div className="gap-sm flex flex-1 flex-col">{t1}{t3}{t4}</div>;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
};
export default VaultHeroLoading;
function _temp(part, index) {
  return <div key={index} className="relative max-w-full"><span className="text-title-lg max-sm:text-title-md invisible block break-all">{part}</span><Skeleton className="absolute inset-0" /></div>;
}